import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const svgImageAttr = makeAttrStruct([
    ['href'],
    ['width', '100'], // Default width
    ['height', '100'], // Default height
    ['style']
]);
export const svgImageData = makeDataStruct();
export const svgImageModel = makeStruct([
    ['attributes', svgImageAttr],
    ['data', svgImageData]
]);
// Simplified Model
export function svgImage(attributes, data) {
    return {
        attributes: attributes || svgImageAttr('100', '100', '0', '0'),
        data: data || svgImageData()
    };
}
/** Creates a Ellipse Shape for an SVG */
export default class SVGIMAGE extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.IMAGE, model);
    }
}
